import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public token: string;
    sidebarService: any;

    constructor(private http: HttpClient) {
        var currentUser = JSON.parse(localStorage.getItem('currentIMEXUser'));
        this.token = currentUser && currentUser.token;
    }

    login(user) {
        var data = "grant_type=password&username=" + user.username + "&password=" + user.password;

        return this.http.post('Token', data)
            .pipe(
                map((response: any) => {
                    let token = response.access_token;
                    if (token) {
                        this.token = token;
                        localStorage.setItem('currentIMEXUser', JSON.stringify({ username: user.username, token: token, licensekey: response.licensekey, DeleteWhseLPs: response.DeleteWhseLPs }));
                        return true;
                    } else {
                        console.log('token invalid map');
                        return false;
                    }
                })
            );
    }

    logout(): void {
        this.token = null;
        localStorage.removeItem('currentIMEXUser');
    }

    getModuleAccess = function () {
        return this.http.get('api/Core/GetUserModulesAccess')
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }

    changePassword(data) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        let urlData = JSON.stringify(data);
        let lstParam = "api/Core/ChangePassword";
        return this.http.post(lstParam, urlData, { headers: headers, observe: 'response' })
            .pipe(
                map(response => {
                    return response;
                }),
                catchError((err) => {
                    return throwError(err)
                })
            );
    }

}